import angular from 'angular'

import myPieceForm from './directives/forms/myPieceForm'
import myPiecesEditForm from './directives/forms/myPiecesEditForm'
import myPiecesForm from './directives/forms/myPiecesForm'

import pieceIcons from './resources/icons.resource'
import pieceFields from './resources/fields.resource'
import pieceLabels from './resources/labels.resource'

import pieceAsk from './services/ask.service'
import pieceFormat from './services/format.service'
import pieceGo from './services/go.service'
import pieceLocal from './services/local.service'
import pieceMetadata from './services/metadata.service'
import pieceResource from './services/resource.service'
import pieceRequest from './services/request.service'
import piece from './services/piece.service'

const name = 'piece'

angular.module(name, [])
  .directive('myPieceForm', myPieceForm)
  .directive('myPiecesEditForm', myPiecesEditForm)
  .directive('myPiecesForm', myPiecesForm)

  .factory('pieceLabels', pieceLabels)
  .factory('pieceFields', pieceFields)
  .factory('pieceIcons', pieceIcons)

  .factory('pieceAsk', pieceAsk)
  .factory('pieceFormat', pieceFormat)
  .factory('pieceGo', pieceGo)
  .factory('pieceLocal', pieceLocal)
  .factory('pieceMetadata', pieceMetadata)
  .factory('pieceResource', pieceResource)
  .factory('pieceRequest', pieceRequest)
  .factory('$$piece', piece)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/piece.module.js